import React from 'react';

import { cn } from 'src/component/ds/utils';
import { SidebarMenuAction } from 'src/component/ds/ui/sidebar';
import { navActionClassName } from './navRow';

interface DeviceNavRowActionProps {
  label: string;
  icon: React.ReactNode;
  onClick?: () => void;
}

export default function DeviceNavRowAction ({ label, icon, onClick }: DeviceNavRowActionProps) {
  return (
    <SidebarMenuAction
      aria-label={label}
      title={label}
      onClick={onClick}
      className={cn(navActionClassName, 'ds-right-2 ds-w-6 peer-data-[size=default]/menu-button:ds-top-[7px]')}
    >
      {icon}
    </SidebarMenuAction>
  );
}
